// extracted by mini-css-extract-plugin
module.exports = {"actions":"actions___2CJwy","count":"count___135QK","cell":"cell___3CJdt","name":"name___2ENUg","table":"table___3BgPJ"};